import { createSelector } from 'reselect';

import { SEARCH_KEY_TEXT_MAP } from 'app/Search/const';

const DEFAULT = {};

const searchSelector = state => {
  const { context } = state.search;
  return state.search[context] || DEFAULT;
};

const DEFAULT_FILTERS = [];

/**
 * make a filters selector
 * @returns {Function} a filters selector
 */
const makeFilters = function makeFilters() {
  return createSelector(searchSelector, search => {
    const { filters = DEFAULT_FILTERS } = search;
    return filters.map(({ k, v }) => ({
      text: SEARCH_KEY_TEXT_MAP[k] || k,
      key: k,
      val: v
    }));
  });
};

export default makeFilters;
